import { useEffect, useRef } from "react";
import crown from "../../assets/svgs/crown.svg";
import prf from "../../assets/svgs/prf.svg";

const LeaderboardModal = ({ names = [], showModal, setShowModal }) => {
  const modal = useRef(null);

  useEffect(() => {
    if (showModal) {
      modal.current.style.display = "flex";
      modal.current.style.justifyContent = "center";
      modal.current.style.animation = "showa 0.6s both";
    }
  }, [showModal]);

  const animEnd = () => {
    if (
      window.getComputedStyle(modal.current).getPropertyValue("opacity") == 0
    ) {
      modal.current.style.display = "none";
    }
  };

  const hideModal = () => {
    modal.current.style.animation = "hidea 0.6s both";
    setShowModal(false);
  };

  const close = () => {
    hideModal();
  };

  const topThree = names.slice(0, 3);
  const others = names.slice(3);

  return (
    <div ref={modal} onAnimationEnd={animEnd} className="modal leaderboard">
      
      <div>
          <div className="leaderboard-container">
            <button onClick={close} className="modal-close-btn" aria-label="Close">
    &times;
  </button>
          <h2 className="title"><b>LEADERBOARD</b></h2>

          <div className="top-three">
            {topThree[1] && (
              <div className="player second">
                <div className="medal">2</div>
                <div><img src={prf} alt="" /></div>
                <p>{topThree[1].name}</p>
                {/* <span>{topThree[1].score ?? "0000"}</span> */}
              </div>
            )}
            {topThree[0] && (
              <div className="player first">
                <div className="crown"><img src={crown} alt="" /></div>
                <div><img src={prf} alt="" /></div>
                <p>{topThree[0].name}</p>
                {/* <span>{topThree[0].score ?? "0000"}</span> */}
              </div>
            )}
            {topThree[2] && (
              <div className="player third">
                <div className="medal">3</div>
                <div><img src={prf} alt="" /></div>
                <p>{topThree[2].name}</p>
                {/* <span>{topThree[2].score ?? "0000"}</span> */}
              </div>
            )}
          </div>

          <div className="rank-list">
            {others.map((player, index) => (
              <div className="rank-item" key={index + 4}>
                <span>{index + 4}</span>
                <div className="prf">
                  <img src={prf} alt="" /> {player.name}
                </div>
                {/* <b>{player.score ?? "0000"}</b> */}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaderboardModal;
